import { render, staticRenderFns } from "./order_packing_checklist.vue?vue&type=template&id=36859a1a&scoped=true"
import script from "./order_packing_checklist.vue?vue&type=script&lang=js"
export * from "./order_packing_checklist.vue?vue&type=script&lang=js"
import style0 from "./order_packing_checklist.vue?vue&type=style&index=0&id=36859a1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36859a1a",
  null
  
)

export default component.exports